import React from "react";

export default function ML_Intro() {
  return (
    <div>
      <h1>ML_Intro</h1>
      <p>This is the ML_Intro component.</p>
    </div>
  );
}
